<template>
  <page-layout>
    <about-section></about-section>
    <div class="divider relative w-full h-20 bg-site-600">
    </div>
    <skill-content></skill-content>
  </page-layout>
</template>
<script>
import PageLayout from '@/layouts/PageLayout.vue';
import AboutSection from '@/views/about/AboutSection.vue';
import SkillContent from '@/views/about/carousel/SkillContent.vue';

export default {
  name: 'About',

  components: {
    PageLayout,
    AboutSection,
    SkillContent,
  },
  created() {
    this.$store.dispatch('UPDATE_TITLE_STATE', { value: 'about' });
  },
};
</script>
<style scoped>
  .divider::after {
    background-color: var(--site-b);
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 70%, 77% 0%, 0% 45%, 0 60%);
    clip-path: polygon(0 0, 100% 0, 100% 70%, 77% 0%, 0% 45%, 0 60%);
     content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }
</style>
